<div class="largeModelContainer">
  <div class="">
    <a class="cancelBtn cancelBtnPosn" (click)="onCancelClick()"></a>
  </div>
  <div class="modelTitle alignCenter ">
    Connector Specification
  </div>
  <div class="modelBody">
    <form #connectorSpecificationForm="ngForm">
      <div class="pl-4 pr-4" [ngClass]="{'readOnly' : readOnly}">
        <div class="form-group row no-overflow connectors-form-group">
          <div class="col-sm-12">
            <div class="row mb-2">
              <div class="col-sm-3">
                <div class="row mb-2">
                  <div class="col-sm-12">
                    <label for="sourceComp" class="form-label">
                      <strong>Source Component: </strong>
                      <span *ngIf="srcModel.componentUniqueId && srcModel.componentUniqueId.length<=15">{{srcModel.componentUniqueId}}</span>
                      <span *ngIf="srcModel.componentUniqueId && srcModel.componentUniqueId.length>15" ngbTooltip="{{srcModel.componentUniqueId}}" placement="bottom">{{srcModel.componentUniqueId.slice(0,15)}}</span>
                      <span *ngIf="srcModel.componentUniqueId && srcModel.componentUniqueId.length>15">...</span>
                    </label>
                  </div>
                </div>
                <div class="row mb-2">
                  <div class="d-flex table-container">
                    <div class="col-12">
                      <div class="example-container">
                        <div class="drag-drop-container-header">Output Variables</div>
                        <div cdkDropList
                             #srcOutputParametersList="cdkDropList"
                             [cdkDropListData]="srcOutputParameters"
                             [cdkDropListConnectedTo]="[srcVariablesList]"
                             class="drag-drop-container-list"
                             (cdkDropListDropped)="drop($event)">
                          <div class="drag-drop-container-box" *ngFor="let item of srcOutputParameters" cdkDrag>
                            {{item.data.captionName}}
                          </div>
                        </div>
                      </div>
                      <div *ngIf="srcModel.outputParameters.length === 0" class="emptyRepoMsg">
                        No parameters available
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-sm-6">
                <div class="connectorContainer">
                  <div class="connectorSrcContainer">
                    <div class="drag-drop-container-header">Source Variables</div>
                    <div cdkDropList
                         #srcVariablesList="cdkDropList"
                         [cdkDropListData]="srcConnParameterList"
                         [cdkDropListConnectedTo]="[srcOutputParametersList]"
                         class="drag-drop-container-list"
                         (cdkDropListDropped)="drop($event)">
                      <div class="drag-drop-container-box" *ngFor="let item of srcConnParameterList" cdkDrag>
                        {{item.data.captionName}}
                        <button class="actionIcon pointer matIconLink" mat-icon-button><mat-icon>link</mat-icon></button>
                      </div>
                    </div>
                  </div>
                  <div class="connectorSrcContainer">
                    <div class="drag-drop-container-header">Sink Variables</div>
                    <div cdkDropList
                         #sinkVariablesList="cdkDropList"
                         [cdkDropListData]="sinkConnParameterList"
                         class="drag-drop-container-list"
                         [cdkDropListConnectedTo]="[srcInputParametersList]"
                         (cdkDropListDropped)="drop($event)">
                      <div class="drag-drop-container-box" *ngFor="let item of sinkConnParameterList ;let i = index" cdkDrag>
                        {{item.data.captionName}}
                        <button class="actionIcon pointer" (click)="deleteMapping(i)" matTooltip="Delete" mat-icon-button>
                          <mat-icon class="action-icon-delete"></mat-icon>
                        </button>
                      </div>
                    </div>
                  </div>
                  <div class="clear"></div>
                </div>
              </div>
              <div class="col-sm-3">
                <div class="row mb-2">
                  <div class="col-sm-12">
                    <label for="sinkComp" class="form-label">
                      <strong>Sink Component: </strong>
                      <span *ngIf="sinkModel.componentUniqueId.length<=15">{{sinkModel.componentUniqueId}}</span>
                      <span *ngIf="sinkModel.componentUniqueId.length>15" ngbTooltip="{{sinkModel.componentUniqueId}}" placement="bottom">{{sinkModel.componentUniqueId.slice(0,15)}}</span>
                      <span *ngIf="sinkModel.componentUniqueId.length>15">...</span>
                    </label>
                  </div>
                </div>
                <div class="row mb-2">
                  <div class="d-flex table-container">
                    <div class="col-12">
                      <div class="example-container">
                        <div class="drag-drop-container-header">Input Variables</div>
                        <div cdkDropList
                             #srcInputParametersList="cdkDropList"
                             [cdkDropListData]="sinkInputParameters"
                             [cdkDropListConnectedTo]="[sinkVariablesList]"
                             class="drag-drop-container-list"
                             (cdkDropListDropped)="drop($event)">
                          <div class="drag-drop-container-box" *ngFor="let item of sinkInputParameters" cdkDrag>
                            {{item.data.captionName}}
                          </div>
                        </div>
                      </div>
                      <div *ngIf="sinkModel.inputParameters.length === 0" class="emptyRepoMsg">
                        No parameters available
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="modelFooter">
        <button class="saveBtn2 actionBtn" *ngIf="!readOnly" [disabled]="!(srcConnParameterList.length === sinkConnParameterList.length)" (click)="saveConnectorSpecification()">Save</button>
        <button *ngIf="readOnly" type="button" class="saveBtn2 actionBtn" (click)="onCancelClick()">Close</button>
        <div class="clear"></div>
      </div>
    </form>
  </div>
  </div>

